import { VenueCategoryUnionType, VenueMinifiedType } from '@api';
import { SearchTableInput, Tabs, useManageTableContext } from '@common';
import { AddVenue, VenuesOverviewTable } from '@features';
import { Box, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '../_layout';

type VenuesPagePropsType = {
  venues: VenueMinifiedType[];
  venueCategories: VenueCategoryUnionType[];
  isPending: boolean;
};

export const VenuesPage: React.FC<VenuesPagePropsType> = ({
  venues,
  venueCategories,
  isPending,
}) => {
  const { t } = useTranslation('venues');

  const {
    tableArguments: {
      search: { searchValue, setSearchValue },
    },
  } = useManageTableContext();

  const tabs = [
    {
      label: t('TABS.OVERVIEW'),
      value: 'overview',
    },
  ];

  return (
    <PageLayout title={t('TITLE')}>
      <Tabs value="overview">
        <Tabs.TabsList>
          {tabs.map((tab) => (
            <Tabs.Tab key={tab.value} value={tab.value} to={`/venues`}>
              {tab.label}
            </Tabs.Tab>
          ))}
          <Tabs.TabsListActions>
            <AddVenue venueCategories={venueCategories} />
          </Tabs.TabsListActions>
        </Tabs.TabsList>
      </Tabs>
      <Box py="md">
        <Group justify="end" mb="xs">
          <SearchTableInput
            search={searchValue ?? ''}
            setSearchValue={setSearchValue}
          />
        </Group>
        <VenuesOverviewTable venues={venues} isPending={isPending} />
      </Box>
    </PageLayout>
  );
};
